<template>
  <tr v-if="!removed">
    <td data-label="Trade(s)">
      <strong>
        <span v-for="trade in contractor.trades" :key="trade">
          {{ trade }}<br/>
        </span>
      </strong>
    </td>
    <td data-label="Company">
      {{ contractor.company }}
    </td>
    <td data-label="Phone">
      <a :href="'tel:' + phone">
        {{ contractor.phoneNumber }}
      </a>
    </td>
    <td data-label="Mobile">
      <a :href="'tel:' + mobile">
        {{ contractor.mobileNumber }}
      </a>
    </td>
    <td data-label="Email">
      <a :href="'mailto:' + contractor.email" target="_top">
        {{ contractor.email }}
      </a>
    </td>
    <td data-label="Contact Name">
      {{ contractor.contactPersonName }}
    </td>
    <td data-label="Notes">
      {{ contractor.notes }}
    </td>
    <td v-if="contractor.Properties">
      <button class="my-2 btn btn-danger" @click="remove()">
        <i class="fa fa-minus" /> Remove
      </button>
    </td>
    <td v-else>
      <button class="my-2 btn btn-warning" @click="editCont()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteCont()">
        <i class="fa fa-trash" /> Delete
      </button>
      <download-input
        :options="{ label: 'Download vCard', permalink: 'downloadVCard', button: true }"
        :value="{ uuid: contractor.uuid }" />
    </td>
  </tr>
</template>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import Api from '@/vuex/api'
  export default {
    name: 'ContractorRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      phone () {
        if (this.contractor.phoneNumber) {
          return this.contractor.phoneNumber.replace(/\D/g, '')
        } else {
          return ''
        }
      },
      mobile () {
        if (this.contractor.mobileNumber) {
          return this.contractor.mobileNumber.replace(/\D/g, '')
        } else {
          return ''
        }
      },
      contractor () {
        return {
          ...this.object
        }
      }
    },
    data () {
      return {
        removed: false
      }
    },
    methods: {
      async remove () {
        let instance = new Api()
        let propertyUuid = this.contractor.Properties[0].uuid
        await instance.removeContractor(this.contractor.uuid, propertyUuid)
        this.removed = true
      },
      async editCont () {
        this.$emit('edit', { permalink: 'editContractor', uuid: this.contractor.uuid })
      },
      async deleteCont () {
        this.$emit('deleteObject', { permalink: 'deleteContractor', uuid: this.contractor.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/Contractor.vue